import React from 'react'
import './Footer.scss';
// import logo from '../../logo.png';

// Icons //
import {IconContext} from "react-icons"
import {FaTwitter} from "react-icons/fa"
import {FaInstagram} from "react-icons/fa"

const Socials = () => {
    return (
        <IconContext.Provider value={{ style: {fontSize: '28px', color: "rgba(255, 255, 255, .8)"}}}>
        <a className="socialIcon" href="https://twitter.com/capncoverspicks" target="_blank"><FaTwitter /></a>
        <a className="socialIcon" href="https://www.instagram.com/capncoverspicks/" target="_blank"><FaInstagram /></a>
     </IconContext.Provider>
    )
  }

function Footer() {
    return (
        <div id="footer">
            <div className="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-4 footerSpacing">
                <div className="col-md col-xl-3 mb-2">
                    <h3 className="copyright">© Capncovers 2022 </h3>
                    {/* <img className="mt-2" src={logo} alt="logo" /> */}
                </div>
                <div className="col-md col-xl-3 mb-4">
                    <h3 className="copyright">Other Links</h3>
                        <li>
                            <a className="footer-link" href="https://capncovers.com/dashboard">Dashboard</a>
                        </li>
                        <li>
                            <a className="footer-link ms-4" href="#chatraChatExpanded">Support</a>
                        </li>
                </div>
                <div className="col-md col-xl-4 mb-4">
                    <h3 className="copyright">Legal</h3>
                        <li>
                            <a className="footer-link" href="https://capncovers.com/terms-of-service">Terms of Service</a>
                        </li>
                        <li>
                            <a className="footer-link ms-4" href="https://capncovers.com/privacy-policy">Privacy Policy</a>
                        </li>
                </div>
                <div className="col-md col-xl-2 col-right">
                    <Socials />
                </div>
            </div>
        </div>
    )
}

export default Footer
